import React from "react";
import { connect } from "react-redux";

import {injectIntl} from "react-intl";
import {LOWES_DISCLAIMER_EN} from "../../../../misc/fabricatorHardcode";
const GroheCartDisclaimer = (props) => {

  const {intl, fabricatorData, cartItems, showUnlockCalculations, showTotalItems} = props;
  const fabricatorSettings = fabricatorData.settings;

  if (!cartItems.length || !fabricatorSettings.depositDisclaimer || !fabricatorSettings.enableDisclaimer
    || (showUnlockCalculations && !showTotalItems.includes("tax"))) {
    return null
  }

  const getDisclaimerMessage = () => {
    if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
      if (intl.locale === "fr-FR" && intl.messages["transDoc.description_FR._disclaimer"]) {
        return intl.messages["transDoc.description_FR._disclaimer"]
      } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customTranslateDescription_PL._disclaimer"]) {
        return intl.messages["transDoc.customTranslateDescription_PL._disclaimer"]
      } else if (fabricatorData.isLowes) {
        return LOWES_DISCLAIMER_EN
      }
    }
    return fabricatorData.settings.depositDisclaimer
  }

  return (
    <div className="gc-disclaimer">
      {/*<span className="gc-disclaimer__icon"/>*/}
      <div className="gc-disclaimer__message" dangerouslySetInnerHTML={{__html: getDisclaimerMessage()}}/>
    </div>
  );
};

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {showUnlockCalculations, showTotalItems} = store.unlockCalculationsState;

  return {
    cartItems,
    fabricatorData: store.fabricatorState,
    showUnlockCalculations,
    showTotalItems
  };
};

export default injectIntl(
  connect(mapStateToProps)(GroheCartDisclaimer)
)
